export default {
    baseStyle: {
        drawerLoading: {
            justify: 'center',
            py: 8
        },
        drawerGrid: {
            columns: 2,
            spacing: 3
        },
        popoverContent: {
            width: '325px',
            height: '391px',
            p: 2,
            bg: 'webTheme.backgroundDefault',
            border: 0,
            borderRadius: 0,
            boxShadow: 'none',
            _focus: {outline: 'none', boxShadow: 'none'}
        },
        popoverBody: {
            p: 0,
            height: '100%',
            sx: {
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'thin',
                scrollbarColor: 'transparent transparent',
                '&::-webkit-scrollbar': {width: '2px'},
                '&::-webkit-scrollbar-track': {background: 'transparent'},
                '&::-webkit-scrollbar-thumb': {
                    background: 'transparent',
                    borderRadius: '2px'
                },
                '&:hover': {scrollbarColor: 'rgba(0,0,0,0.25) transparent'},
                '&:hover::-webkit-scrollbar-thumb, &:active::-webkit-scrollbar-thumb': {
                    background: 'rgba(0,0,0,0.25)'
                }
            }
        },
        popoverLoading: {
            justify: 'center',
            align: 'center',
            height: '100%'
        },
        popoverList: {
            direction: 'column',
            gap: 2
        }
    }
}